module.exports = __webpack_public_path__ + "static/17-bc0bc743a751bad21f109d6df63a858d.png";